/**
 * Takes an object whose keys are param names and values are strings to encode, and encodes them
 * into a URL parameter string. The entire string should be appended to a path with a preceding `?`,
 * like:
 *      const params = makeUrlParams({
 *          email: 'my@email.com',
 *      });
 *      const myURL = `http://iq.trqk.io/my-page?${params}`;
 * @param paramInputs
 */
export const encodeURLParams = (
    paramInputs: Record<string, string>,
): string => {
    const encodedParamInputs = Object.entries(paramInputs)
        .sort((a, b) => a[0].localeCompare(b[0], 'en'))
        .reduce((acc: string[], [key, value]): string[] => {
            try {
                acc.push(`${key}=${encodeURIComponent(value)}`);
            } catch {
                // if encodeURIComponent fails, don't add the key/value pair to the output
            }

            return acc;
        }, [] as string[]);

    return encodedParamInputs.join('&');
};
